var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',_vm._g(_vm._b({staticClass:"j-card",class:_vm.getClass,style:(_vm.backgroundGradientStyle),attrs:{"rounded":""}},'v-card',_vm.$props,false),_vm.$listeners),[(_vm.headerImageUrl)?_c('v-img',{attrs:{"lazy-src":_vm.headerImageUrl,"src":_vm.headerImageUrl}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }